<template>
  <div class="ui-container">
    <h2>Modals</h2>
    <div class="ui-block inline">
      <Button
        class="primary sm"
        label="Click me"
        @click="toggleModal(modal1Data)"
      />
      <Button
        class="secondary sm"
        label="Click me"
        @click="toggleModal(modal2Data)"
      />
      <Button
        class="red sm"
        label="Click me"
        @click="toggleModal(modal3Data)"
      />
      <Modal
        :title="modal1Data.title"
        :text="modal1Data.text"
        :buttons="modal1Data.buttons"
        :isOpen="modal1Data.isOpen"
        @callbackBtn1="toggleModal(modal1Data)"
        @callbackBtn2="confirmModal"
        @close="toggleModal(modal1Data)"
      />
      <Modal
        :title="modal2Data.title"
        :text="modal2Data.text"
        :buttons="modal2Data.buttons"
        :isOpen="modal2Data.isOpen"
        @callbackBtn1="confirmModal"
        @callbackBtn2="toggleModal(modal2Data)"
        @close="toggleModal(modal2Data)"
      >
        <template v-slot:extra>
          <div class="form-container">
            <input type="text" v-model="modal2Data.form.name" />
            <input type="text" v-model="modal2Data.form.lastname" />
            <v-select
              :options="['France', 'USA', 'UK', 'Portugal']"
              placeholder="Select one or more country"
              multiple
              v-model="modal2Data.form.country"
            />
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="register"
                name="register"
                v-model="modal2Data.form.register"
              />
              <label for="register">Register to the newsletter</label>
            </div>
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="share"
                name="share"
                v-model="modal2Data.form.share"
              />
              <label for="share"
                >Share the user informations with partners</label
              >
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :title="modal3Data.title"
        :text="modal3Data.text"
        :buttons="modal3Data.buttons"
        :isOpen="modal3Data.isOpen"
        @callbackBtn1="confirmModal"
        @callbackBtn2="toggleModal(modal3Data)"
        @close="toggleModal(modal3Data)"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";

const modal1Data = reactive({
  title: "Title",
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tincidunt sem a velit accumsan, non pellentesque ante mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Mauris semper turpis ut enim placerat imperdiet. Nullam id odio in massa luctus varius. Ut auctor non ligula rhoncus lacinia. Sed vel sapien in eros tempus sagittis eget non dui. Vivamus nec scelerisque ligula. Mauris vitae auctor justo. Aliquam non porttitor purus. Nulla blandit varius neque a gravida.",
  buttons: {
    column: false,
    data: [
      {
        label: "Close",
        class: "outline secondary",
      },
      {
        label: "Continue",
        class: "primary",
      },
    ],
  },
});

const modal2Data = reactive({
  title: "User registration",
  text: "Fill the user informations bellow",
  buttons: {
    column: true,
    data: [
      {
        label: "Create user",
        class: "primary",
      },
      {
        label: "Save as draft",
        class: "outline secondary",
      },
    ],
  },
  form: {
    name: "Maurice",
    lastname: "Denis",
    country: ["France", "Portugal"],
    register: true,
    share: true,
  },
});

const modal3Data = reactive({
  title: "#01 - Web developer",
  text: "Are you sure you want to delete this campaing ?",
  buttons: {
    column: true,
    data: [
      {
        label: "Confirm",
        class: "red",
      },
      {
        label: "Cancel",
        class: "outline secondary",
      },
    ],
  },
});

function toggleModal(modal) {
  modal.isOpen = !modal.isOpen;
}

function confirmModal() {
  alert("Validation");
}
</script>
